import request from '@/utils/request'

// 1. 获取商品分类列表
export function getMallCategoryList() {
  return request({
    url: '/api/frontend/mall/category/list',
    method: 'get'
  })
}

// 2. 根据分类查询商品
export function getMallProductList(params) {
  return request({
    url: '/api/frontend/mall/product/list',
    method: 'get',
    params
  })
}

// 3. 商品详情
export function getMallProductDetail(id) {
  return request({
    url: `/api/frontend/mall/product/${id}`,
    method: 'get'
  })
}

// 4. 创建商城订单
export function createMallOrder(data) {
  return request({
    url: '/api/frontend/mall/order/create',
    method: 'post',
    data
  })
}

// 5. 获取我的地址列表
export function getMyAddresses() {
  return request({
    url: '/api/frontend/personal/my-addresses',
    method: 'get'
  })
}

// 6. 获取协议模板
export function getAgreementTemplate(typeCode) {
  return request({
    url: '/api/frontend/agreement/template',
    method: 'get',
    params: { typeCode }
  })
}
